import React from 'react';

import Intro from 'features/common/Intro';
import Main from 'components/UI/Main';
import Bullets from 'features/common/Bullets';
import TabList from 'features/common/TabList';
import TechnologiesSlider from 'features/common/TechnologiesSlider';
import BentoBlock from 'features/common/BentoBlock';
import { Calculator } from 'components/Calculator';
import { calculatorConfig } from './_calculator';
import ProjectsSlider from 'features/common/ProjectsSlider';
import Industries from 'features/common/Industries';
import Testimonials from 'features/common/Testimonials';
import ContactUs from 'features/common/ContactUs';
import SEO from 'components/SEO';

import data from './data.json';

export default function Golang({ pageContext: { pagePath } }) {
  return (
    <>
      <Intro {...data.intro} />
      <Main paddingDisable="top">
        <Bullets {...data.feature} />
        <TabList {...data.services} />
        <TechnologiesSlider {...data.tools} />
        <BentoBlock {...data.softDevServices} />
        <Calculator config={calculatorConfig} />
        <ProjectsSlider projectsKey={pagePath} {...data.projects} />
        <Industries {...data.customSolutions} />
        <Testimonials pageKey={pagePath} {...data.reviews} />
        <ContactUs {...data.getConsultation} />
      </Main>
    </>
  );
}

export const Head = ({ location }) => <SEO {...data.head} {...location} />;
